"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ReactMarkdown;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _reactMarkdown = _interopRequireDefault(require("react-markdown"));
var _excluded = ["containerClassName", "id", "markdown"];
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    reactMarkdown: {
      '& a': {
        color: theme.palette.primary.main
      },
      '& blockquote': {
        background: theme.palette.background.default,
        borderLeft: "10px solid ".concat(theme.palette.grey[500])
      },
      '& h1': (0, _extends2.default)({}, theme.typography.h4, {
        fontWeight: 500
      }),
      '& h3, & h2, & h4, & h5, & h6': (0, _extends2.default)({}, theme.typography.h5, {
        fontWeight: 500
      }),
      '& li, &p': (0, _extends2.default)({}, theme.typography.body1),
      '& strong': {
        fontWeight: 500
      }
    }
  };
});
function ReactMarkdown(_ref) {
  var containerClassName = _ref.containerClassName,
    id = _ref.id,
    _ref$markdown = _ref.markdown,
    markdown = _ref$markdown === void 0 ? '' : _ref$markdown,
    other = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_reactMarkdown.default, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.reactMarkdown, containerClassName),
    id: id
  }, other), markdown);
}